import React, { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { ShoppingCartIcon } from 'lucide-react';
import { MAIN_IMG } from '../utils/constants';
const BUYERS = [{
  name: 'Marco',
  city: 'Roma'
}, {
  name: 'Giulia',
  city: 'Milano'
}, {
  name: 'Alessandro',
  city: 'Napoli'
}, {
  name: 'Francesca',
  city: 'Torino'
}, {
  name: 'Luca',
  city: 'Firenze'
}, {
  name: 'Chiara',
  city: 'Bologna'
}, {
  name: 'Giuseppe',
  city: 'Palermo'
}, {
  name: 'Sofia',
  city: 'Venezia'
}, {
  name: 'Matteo',
  city: 'Genova'
}, {
  name: 'Elena',
  city: 'Verona'
}, {
  name: 'Andrea',
  city: 'Bari'
}, {
  name: 'Valentina',
  city: 'Catania'
}];
export function PurchasePopup() {
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const mountedRef = useRef(true);
  useEffect(() => {
    mountedRef.current = true;
    const showRandomToast = () => {
      if (!mountedRef.current) return;
      const randomBuyer = BUYERS[Math.floor(Math.random() * BUYERS.length)];
      toast.custom(() => <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-3 flex items-center gap-3 max-w-sm w-full" data-id="element-241">
            <img src={MAIN_IMG} alt="Mega-Pack" className="w-12 h-12 rounded-lg object-cover flex-shrink-0" data-id="element-242" />
            <div className="flex-1 min-w-0" data-id="element-243">
              <p className="text-sm text-gray-800 font-medium" data-id="element-244">
                <span className="font-bold" data-id="element-245">{randomBuyer.name}</span> da{' '}
                {randomBuyer.city}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-246">
                Ha appena acquistato questo prodotto
              </p>
            </div>
            <ShoppingCartIcon className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-247" />
          </div>, {
        duration: 4000,
        position: 'bottom-left'
      });
      const nextDelay = Math.floor(Math.random() * (30000 - 15000 + 1) + 15000);
      timeoutRef.current = setTimeout(showRandomToast, nextDelay);
    };
    timeoutRef.current = setTimeout(showRandomToast, 10000);
    return () => {
      mountedRef.current = false;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  return null;
}